// src/components/AdminPanel/StatusSidebar.js
import React from "react";
import "./StatusSidebar.css";

const StatusSidebar = ({ onStatusClick, selectedStatus }) => {
  const statuses = [
    { status: "all", description: "Show all pharmacies" },
    { status: "pending", description: "Registered but not reviewed yet" },
    { status: "approved", description: "Approved by admin, visible on frontend" },
    { status: "rejected", description: "Rejected by admin (not shown to users)" },
    { status: "inactive", description: "Temporarily hidden (e.g., non-payment)" },
  ];

  return (
    <div className="status-sidebar">
      <h3>📊 Status</h3>
      <ul>
        {statuses.map((item) => (
          <li
            key={item.status}
            className={selectedStatus === item.status ? "active" : ""}
            onClick={() => onStatusClick(item.status)}
            style={{ cursor: "pointer", padding: "6px 10px" }}
          >
            <strong>{item.status.charAt(0).toUpperCase() + item.status.slice(1)}:</strong>{" "}
            <span>{item.description}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StatusSidebar;